function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isUserAuthenticated } from "../helpers/authUtils";
import { requireAuth } from "../helpers/requireAuth";

class PrivateRoute extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const {
        component: Component,
        roles,
        ...rest
      } = this.props;
      return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
        render: props => {
          if (!isUserAuthenticated()) {
            // not logged in so redirect to login page with the return url
            return /*#__PURE__*/React.createElement(Redirect, {
              to: {
                pathname: '/account/login',
                state: {
                  from: props.location
                }
              }
            });
          } // authorised so return component


          return /*#__PURE__*/React.createElement(Component, props);
        }
      }));
    });
  }

}

export default requireAuth(PrivateRoute);